// src/components/dialog/DlgPanelAdd.tsx

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material'

import { FolderId, SensorId } from '@/types/domain'
import { KARMA_WizardDialog } from '@/types/karma/dialog'

import {
  DashboardDisplayFolders,
  DlgCloseButton,
  HStack,
  PanelDisplayFolders,
} from '..'

const graphicTypes = [
  { label: 'Kreisdiagramm', value: 1 },
  { label: 'Zeitverlaufdiagramm', value: 2 },
  { label: 'Ranking', value: 3 },
]

const indicatorData = [
  { label: 'Verbrauch', value: 1 },
  { label: 'Verbrauch/m²', value: 2 },
  { label: 'Kosten', value: 3 },
  { label: 'Kosten/m²', value: 4 },
  { label: 'CO₂-Ausstoß', value: 5 },
  { label: 'CO₂-Ausstoß/m²', value: 6 },
]

type DlgPanelFolderProps = KARMA_WizardDialog & {
  data: { folders: FolderId[]; panel: any; mode: 'add' | 'edit' }
  onChange: (panel: any) => void
  setSelectedFolders: (folders: FolderId[]) => void
  setSelectedSensors?: (sensors: SensorId[]) => void
}

export const DlgPanelFolders = ({
  data,
  onChange,
  onClose,
  onGotoNext,
  open,
  setSelectedFolders,
  setSelectedSensors,
}: DlgPanelFolderProps) => (
  <Dialog fullWidth maxWidth={'xl'} open={open}>
    <DialogTitle>
      {data.mode === 'edit' ? (
        <Typography>Kachel Einstellungen</Typography>
      ) : (
        <Typography>Neue Kachel</Typography>
      )}

      <DlgCloseButton onClick={onClose} />
    </DialogTitle>

    <DialogContent sx={{ my: 1 }}>
      <HStack sx={{ width: 1, my: 1 }}>
        <TextField
          fullWidth
          label={'Titel'}
          onChange={event => {
            const name = event.target.value
            onChange({ ...data.panel, name })
          }}
          value={data.panel?.name}
        />

        <TextField
          fullWidth
          label={'Indikator'}
          onChange={event => {
            const indicator = Number(event.target.value)
            onChange({ ...data.panel, indicator })
          }}
          select
          value={data.panel?.indicator || ''}
        >
          {indicatorData.map(item => (
            <MenuItem key={item.value} value={item?.value}>
              {item?.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          label={'Grafiktyp'}
          onChange={event => {
            const graphicType = Number(event.target.value)
            onChange({ ...data.panel, graphic_type: graphicType })
          }}
          select
          value={data.panel?.graphic_type || ''}
        >
          {graphicTypes.map(item => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </TextField>
      </HStack>

      {data.mode === 'add' && (
        <DashboardDisplayFolders
          onChange={setSelectedFolders}
          selected={data.folders}
        />
      )}

      {data.mode === 'edit' && (
        <PanelDisplayFolders
          onChange={setSelectedFolders}
          onChangeSelectedSensors={setSelectedSensors}
          selected={data.folders}
        />
      )}
    </DialogContent>

    <DialogActions>
      <Button onClick={onGotoNext}>Weiter</Button>
    </DialogActions>
  </Dialog>
)
